import _classCallCheck from "D:\\Smartinspect\\react\\smartinspection.ca\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\Smartinspect\\react\\smartinspection.ca\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "D:\\Smartinspect\\react\\smartinspection.ca\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _get from "D:\\Smartinspect\\react\\smartinspection.ca\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/get";
import _getPrototypeOf from "D:\\Smartinspect\\react\\smartinspection.ca\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "D:\\Smartinspect\\react\\smartinspection.ca\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import { AbsorberSizeLimit } from "./AbsorberSizeLimit";
import { ValueWithRandom } from "tsparticles-engine";
export var AbsorberSize = /*#__PURE__*/function (_ValueWithRandom) {
  _inherits(AbsorberSize, _ValueWithRandom);
  function AbsorberSize() {
    var _this;
    _classCallCheck(this, AbsorberSize);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(AbsorberSize).call(this));
    _this.density = 5;
    _this.value = 50;
    _this.limit = new AbsorberSizeLimit();
    return _this;
  }
  _createClass(AbsorberSize, [{
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }
      _get(_getPrototypeOf(AbsorberSize.prototype), "load", this).call(this, data);
      if (data.density !== undefined) {
        this.density = data.density;
      }
      if (typeof data.limit === "number") {
        this.limit.radius = data.limit;
      } else {
        this.limit.load(data.limit);
      }
    }
  }]);
  return AbsorberSize;
}(ValueWithRandom);